/**
 * Opt-in trace logs for i18n/router/bootstrap (default: off).
 * In DevTools: localStorage.setItem('journeyVerboseLogs', '1') then refresh.
 * Remove with localStorage.removeItem('journeyVerboseLogs').
 */
export function journeyVerboseLog(...args) {
  if (typeof window === 'undefined') return
  try {
    if (window.localStorage?.getItem('journeyVerboseLogs') !== '1') return
  } catch {
    return
  }
  console.log(...args)
}
